<template>
  <div id="layout">
    <h2>Layout</h2>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Layout',
  
};
</script>

<style lang="scss" scoped>
#layout {
  color: #999999;
}
</style>